export default "__VITE_ASSET__nkDSuCiX__";